import * as React from 'react';
import {styled, mq} from '../../../utils';
import Flex from '../../../components/Flex';
import FormField from '../../../components/FormField';
import TextField, {TextFieldProps} from '../../../components/TextField';
import {PillButton} from '../../../components/Button';
import {IconCheckCircle} from '../../../components/SvgIcon';
import {FormikProps} from 'formik';

export interface FormValues {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  passwordConfirm: string;
  location: string;
}

interface CohostRegistrationFormBaseProps extends FormikProps<FormValues> {
  loading: boolean;
}

// TODO: Add error message display capability to TextField component.
const ErrorMessage = ({children, show}: {children: React.ReactNode; show: boolean}) => {
  if (show) {
    return <div style={{fontFamily: 'Roboto', color: '#C00', padding: '8px 0'}}>{children}</div>;
  }
  return null;
};

const SubmitButton = styled(PillButton)({
  [mq('laptopAndUp')]: {
    marginBottom: 100
  }
});

export default class CohostRegistrationFormBase extends React.Component<CohostRegistrationFormBaseProps, {}> {
  public render() {
    const {values, errors, touched, handleChange, handleBlur, handleSubmit, loading} = this.props;

    const commonFieldProps: TextFieldProps = {
      onChange: handleChange,
      onBlur: handleBlur,
      large: true,
      iconPosition: 'end'
    };

    // TODO: add success state to TextField component
    const checkCircle = <IconCheckCircle color="#08C173" />;

    return (
      <form onSubmit={handleSubmit}>
        <FormField label="First name">
          <TextField
            autoFocus={true}
            id="firstName"
            value={values.firstName}
            icon={!errors.firstName && touched.firstName && checkCircle}
            {...commonFieldProps}
          />
          <ErrorMessage show={Boolean(errors.firstName && touched.firstName)}>{errors.firstName}</ErrorMessage>
        </FormField>
        <FormField label="Last name">
          <TextField
            id="lastName"
            value={values.lastName}
            icon={!errors.lastName && touched.lastName && checkCircle}
            {...commonFieldProps}
          />
          <ErrorMessage show={Boolean(errors.lastName && touched.lastName)}>{errors.lastName}</ErrorMessage>
        </FormField>
        <FormField label="Email">
          <TextField
            type="email"
            id="email"
            value={values.email}
            icon={!errors.email && touched.email && checkCircle}
            {...commonFieldProps}
          />
          <ErrorMessage show={Boolean(errors.email && touched.email)}>{errors.email}</ErrorMessage>
        </FormField>
        <FormField label="Password">
          <TextField
            type="password"
            id="password"
            value={values.password}
            icon={!errors.password && touched.password && checkCircle}
            {...commonFieldProps}
          />
          <ErrorMessage show={Boolean(errors.password && touched.password)}>{errors.password}</ErrorMessage>
        </FormField>
        <FormField label="Password Confirmation">
          <TextField
            type="password"
            id="passwordConfirm"
            value={values.passwordConfirm}
            icon={!errors.passwordConfirm && touched.passwordConfirm && checkCircle}
            {...commonFieldProps}
          />
          <ErrorMessage show={Boolean(errors.passwordConfirm && touched.passwordConfirm)}>
            {errors.passwordConfirm}
          </ErrorMessage>
        </FormField>
        <FormField label="Location">
          <TextField
            id="location"
            value={values.location}
            icon={!errors.location && touched.location && checkCircle}
            {...commonFieldProps}
          />
          <ErrorMessage show={Boolean(errors.location && touched.location)}>{errors.location}</ErrorMessage>
        </FormField>
        <Flex center={true}>
          <SubmitButton type="submit" variant="primary" loading={loading} large={true}>
            Next step
          </SubmitButton>
        </Flex>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CohostRegistrationForm/private/CohostRegistrationFormBase.tsx